import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from './model';

export const usePricing = (data, screen, setSelected, track) => {
  const [services, setServices] = useState({});
  const [loadedKey, setLoadedKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const key = JSON.stringify({ objective: 'autre', property_type: data.property_type, profile_type: data.profile_type,
    address: data.address, surface: data.surface || null, lot_count: data.lot_count || null,
    heating_type: data.heating_type || null, is_collective_heating: data.is_collective_heating });
  const active = ['prix', 'visite'].includes(screen);
  useEffect(() => {
    if (!active) return;
    const controller = new AbortController();
    setLoading(true); setError('');
    axios.post(`${API}/api/calculate_pricing`, JSON.parse(key), { signal: controller.signal }).then(({ data: response }) => {
      if (controller.signal.aborted) return;
      setServices(response.services); setLoadedKey(key);
      setSelected((previous) => Object.fromEntries(Object.entries(response.services).filter(([name]) => name !== 'reequilibrage').map(([name, service]) => [name,
        previous[name] !== undefined ? previous[name] : JSON.parse(key).property_type === 'immeuble' && service.mandatory && service.badge === 'INCLUS'])));
    }).catch(() => {
      if (!controller.signal.aborted) { setError('Votre prix n’a pas pu être calculé. Réessayez dans un instant.'); track('error', 'prix', { code: 'PRICING_FAILED' }); }
    }).finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [key, active, setSelected, attempt, track]);
  return { services, ready: key === loadedKey, loading, error, retry: () => setAttempt((count) => count + 1) };
};